'use client'
import { apiSubscribeNewsletter } from '@/apis/page_optimization';
import { faPaperPlane, FontAwesomeIcon } from '@/constants/icons';
import React, { useState } from 'react'
import { toast } from "react-toastify";
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { apiVerifyCaptcha } from '@/apis/captcha';

interface Props {
    domain: string;
    companyId: string;
}

const FooterNewsletterRedesign = ({ domain, companyId }: Props) => {
    const [email, setEmail] = useState<string>("");
    const [status, setStatus] = useState<'idle' | 'verifying' | 'sending' | 'failed'>('idle');

    const { executeRecaptcha } = useGoogleReCaptcha();

    const validateEmail = (emailStr: string) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(emailStr);
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!email.trim()) {
            toast.error('Email field is required.', { autoClose: 2000 });
            return;
        }
        if (!validateEmail(email)) {
            toast.error("Please enter a valid email address.", { autoClose: 2000 });
            return;
        }
        if (!executeRecaptcha) {
            toast.error('reCAPTCHA not ready. Please try again.', { autoClose: 2000 });
            return;
        }

        try {
            setStatus('verifying');
            const recaptchaToken = await executeRecaptcha('newsletter_form');
            const captchaRes = await apiVerifyCaptcha(domain, recaptchaToken);

            if (!captchaRes?.verified) {
                setStatus('failed');
                toast.error('Captcha verification failed. Please try again.', { autoClose: 2000 });
                return;
            }

            setStatus('sending');
            const response = await apiSubscribeNewsletter(companyId, email);

            if (response?.status === 200 || response?.status === true || response?.message === "Subscribed successfully") {
                toast.success("Thank you for subscribing!", { autoClose: 2000 });
                setEmail("");
            } else {
                toast.error(response?.message || "You have already subscribed to our newsletter.");
            }
        } catch (error) {
            console.error("Error subscribing:", error);
            toast.error('Failed to subscribe. Please try again later.', { autoClose: 2000 });
        } finally {
            setStatus('idle');
        }
    };

    return (
        <form className="ftr-news-form" onSubmit={handleSubmit} autoComplete="off">
            <div className="ftr-news-field">
                <input
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <button type="submit" className="ftr-news-btn" disabled={status !== 'idle'} aria-label="Subscribe">
                    <FontAwesomeIcon icon={faPaperPlane} style={{ width: '16px', height: '16px' }} />
                </button>
            </div>
        </form>
    )
}

export default FooterNewsletterRedesign;
